module.exports = __webpack_public_path__ + "img/favicon_360.7a8b085c.png";